<div *ngIf="CanShow === 1 ">
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
      <div class="card" *ngIf="CurrentActorContactInfoController.ActorCode >0">
        <div class="card-header  wh-header">
          <div class="row">
            <div class="col-md-10 pink">
              CONTACTS &amp; EMERGENCY INFORMATION
            </div>
            <div class="col-md-2 float-right" *ngIf="CanEdit === 1 ">
              <a (click)="OpenEditContent()"><span class="badge badge-pink"> <i class="fa fa-edit"></i></span></a>
            </div>
          </div>
        </div>
        <!--<div class="card-header">
          <h5>Contact Details</h5>
          <div class="col-md-4 col-sm-6 col-12 fonticon-container">
            <div class="fonticon-wrap">
              <button class="ft-edit" (click)="OpenEditContent()"> </button>
            </div>

          </div>
        </div>-->
        <div class="card-body">
          <div class="card-block">
            <div class="row">



              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.AddressLine1">
                <div class="form-group">
                  <label><a> Current Address:</a></label>
                  <span>{{CurrentActorContactInfoController.AddressLine1}}  </span>
                  <span>  {{CurrentActorContactInfoController.AddressLine2}}</span>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.City">
                <div class="form-group">
                  <label><a> City:</a></label>
                  <span>{{CurrentActorContactInfoController.City}}</span>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.State">
                <div class="form-group">
                  <label><a>State:</a></label>

                  <a>{{CurrentActorContactInfoController.State}}</a>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Country">
                <div class="form-group">
                  <label><a> Country:</a></label>
                  <span>{{CurrentActorContactInfoController.CountryLongValue}}</span>
                </div>
              </div>



              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Telephone1">
                <div class="form-group">
                  <label><a> Cell Phone:</a></label>
                  <a>{{CurrentActorContactInfoController.Telephone1}}</a>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Telephone2">
                <div class="form-group">
                  <label><a> Telephone:</a></label>
                  <span>{{CurrentActorContactInfoController.Telephone2}}</span>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Email">
                <div class="form-group">
                  <label><a> Email:</a></label>
                  <span>{{CurrentActorContactInfoController.Email}}</span>
                </div>
              </div>


              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.EmergencyContactPersonName">
                <div class="form-group">
                  <label><a><i></i>Emergency Contact:</a></label>
                  <a>{{CurrentActorContactInfoController.EmergencyContactPersonName}}</a>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.EmergencyContactNo1">
                <div class="form-group">
                  <label><a><i></i>Emergency ContactNo:</a></label>
                  <span>{{CurrentActorContactInfoController.EmergencyContactNo1}}</span>
                </div>
              </div>

              <div class="col-md-4" *ngIf="CurrentActorContactInfoController.EmergencyAddress">
                <div class="form-group">
                  <label><a><i></i>Emergency Address:</a></label>
                  <span>{{CurrentActorContactInfoController.EmergencyAddress}}</span>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    </div>
    <div *ngIf="CanShowRegistryView === 1 && CurrentActorContactInfoController ">
      <div class="row card-deck">
        <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12 my-profile-form">
          <div class="card" *ngIf="CurrentActorContactInfoController.ActorCode >0">
            <div class="card-header wh-header">
              <div class="row">
                <div class="col-md-10 pink">
                  CONTACTS &amp; EMERGENCY INFORMATION
                </div>

              </div>
            </div>

            <div class="card-body">
              <div class="card-block">
                <div class="row">



                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.AddressLine1">
                    <div class="form-group">
                      <label><a> Current Address:</a></label>
                      <span>{{CurrentActorContactInfoController.AddressLine1}}  </span>
                      <span>  {{CurrentActorContactInfoController.AddressLine2}}</span>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.City">
                    <div class="form-group">
                      <label><a> City:</a></label>
                      <span>{{CurrentActorContactInfoController.City}}</span>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.State">
                    <div class="form-group">
                      <label><a>State:</a></label>

                      <a>{{CurrentActorContactInfoController.State}}</a>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Country">
                    <div class="form-group">
                      <label><a> Country:</a></label>
                      <span>{{CurrentActorContactInfoController.CountryLongValue}}</span>
                    </div>
                  </div>



                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Telephone1">
                    <div class="form-group">
                      <label><a> Cell Phone:</a></label>
                      <a>{{CurrentActorContactInfoController.Telephone1}}</a>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Telephone2">
                    <div class="form-group">
                      <label><a> Telephone:</a></label>
                      <span>{{CurrentActorContactInfoController.Telephone2}}</span>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.Email">
                    <div class="form-group">
                      <label><a> Email:</a></label>
                      <span>{{CurrentActorContactInfoController.Email}}</span>
                    </div>
                  </div>


                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.EmergencyContactPersonName">
                    <div class="form-group">
                      <label><a><i></i>Emergency Contact:</a></label>
                      <a>{{CurrentActorContactInfoController.EmergencyContactPersonName}}</a>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.EmergencyContactNo1">
                    <div class="form-group">
                      <label><a><i></i>Emergency ContactNo:</a></label>
                      <span>{{CurrentActorContactInfoController.EmergencyContactNo1}}</span>
                    </div>
                  </div>

                  <div class="col-md-4" *ngIf="CurrentActorContactInfoController.EmergencyAddress">
                    <div class="form-group">
                      <label><a><i></i>Emergency Address:</a></label>
                      <span>{{CurrentActorContactInfoController.EmergencyAddress}}</span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>




